export interface IQuery {
  id: number;
  title: string;
  createdAt: string;
  data: string;
  username: string;
  labType: string;
  historicDatabaseName?: string;
}

export interface ICreateUpdateQueryRequest {
  id?: number;
  title: string;
  data: string;
  labType: string;
  historicDatabaseName?: string;
}
